/* ============================================================
   section-page-content-checkout-bb-assortment.js
   ============================================================ */

/* ------------------------------------------------------------------
   Shared state
   activeProductVariantId is set on page load from checkoutBundleVars
   and updated live by the multi-product toggle whenever the user
   switches between bundle options.
------------------------------------------------------------------ */
window.activeProductVariantId =
  window.checkoutBundleVars?.productVariantsFirstId ?? null;

/**
 * Returns the variant ID to add to cart.
 * Prefers the live toggle selection; falls back to the static default.
 */
function getActiveVariantId() {
  return (
    window.activeProductVariantId ||
    window.checkoutBundleVars?.productVariantsFirstId
  );
}

/* ------------------------------------------------------------------
   Scroll-to-purchase CTA buttons (header / hero)
------------------------------------------------------------------ */
document.querySelectorAll(".static-cta button, button.scroll").forEach((btn) => {
  btn.addEventListener("click", () => {
    const target = document.querySelector(".options-bracket");
    if (target) window.scrollTo({ top: target.offsetTop, behavior: "smooth" });
  });
});

/* ------------------------------------------------------------------
   DOMContentLoaded
------------------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", () => {

  /* ── Countdown timer (30 min) ─────────────────────────────────── */
  const deadline = Date.now() + 30 * 60 * 1000;

  const timerInterval = setInterval(() => {
    const remaining = deadline - Date.now();
    if (remaining <= 0) {
      clearInterval(timerInterval);
      setTimerDisplay("00", "00");
      return;
    }
    const mins = Math.floor((remaining / 60000) % 60);
    const secs = Math.floor((remaining / 1000) % 60);
    setTimerDisplay(String(mins).padStart(2, "0"), String(secs).padStart(2, "0"));
  }, 1000);

  function setTimerDisplay(mins, secs) {
    const mEl = document.querySelector(".countdown-timer .minutes");
    const sEl = document.querySelector(".countdown-timer .seconds");
    if (mEl) mEl.textContent = mins;
    if (sEl) sEl.textContent = secs;
  }

  /* ── Hide save-var1 spans on load ─────────────────────────────── */
  document.querySelectorAll(".save-var1").forEach((el) => (el.style.display = "none"));

  /* ── Sync loop-widget prices with active size on load ─────────── */
  syncPricesFromActiveVariant();
  setTimeout(syncPricesFromActiveVariant, 1500); // retry after loop widget renders

  /* ── Loop widget: purchase-option radio toggle ────────────────── */
  document.querySelectorAll('input[name="purchase-option"]').forEach((radio) => {
    radio.addEventListener("change", (e) => {
      document.querySelectorAll(".loop-widget-purchase-option").forEach((opt) =>
        opt.classList.remove("loop-widget-purchase-option-selected")
      );

      const selector =
        e.target.id === "onetime-purchase-radio"
          ? ".loop-widget-purchase-option-onetime"
          : "#loop-widget-purchase-option-id-091440bb412697c5c97504cf99d91f4cfaf82095";

      document.querySelector(selector)?.classList.add("loop-widget-purchase-option-selected");
    });
  });

  /* ── Loop widget container: sub ↔ one-time price display swap ─── */
  document.querySelector(".loop-widget-container")?.addEventListener("click", () => {
    const label = getSelectedPurchaseLabel();
    togglePriceDisplay(label === "One-time purchase");
    changeSaveDesc();
  });

  /* ── Size selector (custom-selectbutton) click ────────────────── */
  document.querySelector(".custom-selectbutton")?.addEventListener("click", () => {
    const flatPrice = document.querySelector(".is-active .pricehidden-flatprice");
    const subPrice  = document.querySelector(".is-active .pricehidden-subprice");
    const subsWidget = document.querySelector(
      ".loop-widget-purchase-option-subscription .loop-widget-purchase-option-price"
    );
    const otWidget = document.querySelector(
      ".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price"
    );

    if (flatPrice && subPrice) {
      if (subsWidget) subsWidget.innerHTML = subPrice.value;
      if (otWidget)   otWidget.innerHTML   = flatPrice.value;
    }

    if (getSelectedPurchaseLabel() !== "One-time purchase") changeSaveDesc();

    /* Size-based carousel sync (checkout-bb-sherri only) */
    if (window.checkoutBundleVars?.requestPath === "/pages/checkout-bb-sherri") {
      const selectedBroth  = document.querySelector(".selected-broth");
      const activeSubprice = document.querySelector(".is-active .sizeselector-subprice");
      if (
        selectedBroth?.getAttribute("data-size-based-image") === "true" &&
        activeSubprice
      ) {
        const idx     = activeSubprice.getAttribute("data-id");
        const splideEl = document.querySelector(".product__media-slider .x-splide");
        if (splideEl?.splide) splideEl.splide.go(idx - 1);
      }
    }
  });

  /* ── Ingredients / nutrition modal ───────────────────────────── */
  const modal = document.getElementById("ingredientsModal");
  if (modal) {
    const modalImg = modal.querySelector(".modal-img");
    const closeBtn = modal.querySelector(".btn-close");
    const dialog   = modal.querySelector(".modal-dialog");

    document.querySelectorAll(".modalTrigger").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const src = btn.getAttribute("data-bs-target");
        if (src) modalImg.src = src;
        modal.classList.add("show");
        modal.style.display = "block";
      });
    });

    const closeModal = () => {
      modal.classList.remove("show");
      modal.style.display = "none";
      modalImg.src = "";
    };

    closeBtn?.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (!dialog.contains(e.target)) closeModal();
    });
  }

  /* ── Default size option click (e.g. "4 Boxes") ──────────────── */
  const defaultValue = window.checkoutBundleVars?.defaultValue;
  const defaultSpan  = document.querySelector(`.span-wrap[data-value='${defaultValue}']`);
  if (defaultSpan) defaultSpan.click();
});

/* ------------------------------------------------------------------
   Add-to-cart: .submit  (one-time OR subscription based on setting)
   Uses getActiveVariantId() so it always reflects the toggled product.
------------------------------------------------------------------ */
document.querySelectorAll(".submit").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();

    const variantId = getActiveVariantId();
    if (!variantId) return;

    const isSubscription =
      window.checkoutBundleVars?.purchaseOptionType === "subscription";

    const url = isSubscription
      ? buildCartUrl(variantId, { discount: null })
      : buildCartUrl(variantId, { discount: "assortment20" });

    window.location.href = url;
  });
});

/* ------------------------------------------------------------------
   Add-to-cart: .subsubmit  (subscribe & save)
   Uses getActiveVariantId() so it always reflects the toggled product.
------------------------------------------------------------------ */
document.querySelectorAll(".subsubmit").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();

    const variantId = getActiveVariantId();
    if (!variantId) return;

    window.location.href = buildCartUrl(variantId, {
      sellingPlan: "2122481777",
      discount: "21DAYBBSUB125",
    });
  });
});

/* ------------------------------------------------------------------
   Helpers
------------------------------------------------------------------ */

/**
 * Build a Shopify cart/clear → cart/add → checkout URL.
 * @param {string} variantId
 * @param {{ sellingPlan?: string, discount?: string|null }} opts
 */
function buildCartUrl(variantId, { sellingPlan = null, discount = null } = {}) {
  let addParams = `items[0][id]=${variantId}&items[0][quantity]=1`;
  if (sellingPlan) addParams += `&items[0][selling_plan]=${sellingPlan}`;

  const returnTo = discount
    ? `/checkout?discount=${discount}`
    : `/checkout`;

  const innerReturnTo = encodeURIComponent(`/cart/add?${addParams}&return_to=${returnTo}`);
  return `https://drkellyann.com/cart/clear?return_to=${innerReturnTo}`;
}

/**
 * Toggle flat vs. subscription price-per-packet display across all size options.
 * @param {boolean} showFlat – true = one-time, false = subscription
 */
function togglePriceDisplay(showFlat) {
  document.querySelectorAll(".sizeselector-flatprice")
    .forEach((el) => (el.style.display = showFlat ? "block" : "none"));
  document.querySelectorAll(".sizeselector-subprice")
    .forEach((el) => (el.style.display = showFlat ? "none" : "block"));
  document.querySelectorAll(".save .save-flat")
    .forEach((el) => (el.style.display = showFlat ? "block" : "none"));
  document.querySelectorAll(".save .save-sub")
    .forEach((el) => (el.style.display = showFlat ? "none" : "block"));
  document.querySelectorAll(".save-var1")
    .forEach((el) => (el.style.display = showFlat ? "none" : "block"));
  document.querySelectorAll(".newpricetagtest")
    .forEach((el) => (el.style.display = showFlat ? "none" : "block"));
}

/**
 * Sync the loop-widget discount badge and description text
 * with the active size option's discount percentage.
 * Only runs when the product is in the target collection.
 */
function changeSaveDesc() {
  if (!window.checkoutBundleVars?.isInTargetCollection) return;

  const badge          = document.querySelector(".loop-widget-purchase-option-discount-badge");
  const activeDiscount = document.querySelector(".is-active .save .save-sub");
  const discountText   =
    activeDiscount?.innerHTML.includes("%") ? activeDiscount.innerHTML : "Save 10%";

  if (badge?.innerHTML.includes("%")) badge.innerHTML = discountText;

  document
    .querySelectorAll(".loop-widget-purchase-option .loop-widget-sp-selector-description")
    .forEach((desc) => {
      if (desc.innerHTML.includes("Save") && desc.innerHTML.includes("%")) {
        desc.innerHTML = desc.innerHTML.replace(/Save \d+%/, discountText);
      }
    });
}

/**
 * Sync loop-widget subscription / one-time price displays
 * with the active size option's hidden price inputs.
 */
function syncPricesFromActiveVariant() {
  const flatPrice  = document.querySelector(".is-active .pricehidden-flatprice");
  const subPrice   = document.querySelector(".is-active .pricehidden-subprice");
  const subsWidget = document.querySelector(
    ".loop-widget-purchase-option-subscription .loop-widget-purchase-option-price"
  );
  const otWidget   = document.querySelector(
    ".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price"
  );

  if (flatPrice && subPrice) {
    if (subsWidget) subsWidget.innerHTML = subPrice.value;
    if (otWidget)   otWidget.innerHTML   = flatPrice.value;
  }
}

/**
 * Get the text label of the currently selected loop-widget purchase option.
 * @returns {string}
 */
function getSelectedPurchaseLabel() {
  return (
    document.querySelector(
      ".loop-widget-purchase-option-selected .loop-widget-purchase-option-label"
    )?.innerHTML ?? ""
  );
}
